var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWavesBottomGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1280,
    height: 240,
    viewBox: "0 0 1280 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 55 C220 10, 420 100, 640 55 S1060 10, 1280 55",
    fill: "none",
    stroke: "#18B95B",
    strokeWidth: 2,
    opacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 73 C220 28, 420 118, 640 73 S1060 28, 1280 73",
    fill: "none",
    stroke: "#18B95B",
    strokeWidth: 2,
    opacity: 0.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 91 C220 46, 420 136, 640 91 S1060 46, 1280 91",
    fill: "none",
    stroke: "#18B95B",
    strokeWidth: 2,
    opacity: 0.45
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 109 C220 64, 420 154, 640 109 S1060 64, 1280 109",
    fill: "none",
    stroke: "#18B95B",
    strokeWidth: 2,
    opacity: 0.45
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 127 C220 82, 420 172, 640 127 S1060 82, 1280 127",
    fill: "none",
    stroke: "#18B95B",
    strokeWidth: 2,
    opacity: 0.45
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 145 C220 100, 420 190, 640 145 S1060 100, 1280 145",
    fill: "none",
    stroke: "#18B95B",
    strokeWidth: 2,
    opacity: 0.45
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 163 C220 118, 420 208, 640 163 S1060 118, 1280 163",
    fill: "none",
    stroke: "#18B95B",
    strokeWidth: 2,
    opacity: 0.45
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 181 C220 136, 420 226, 640 181 S1060 136, 1280 181",
    fill: "none",
    stroke: "#18B95B",
    strokeWidth: 2,
    opacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavesBottomGreen);
export default __webpack_public_path__ + "static/media/waves_bottom_green.fa2ff41a1aa3bcdef046f3fb60780312.svg";
export { ForwardRef as ReactComponent };